var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_3910)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7613 31.7072C64.0824 31.925 55.9469 26.0239 50.3194 26.1303C44.6919 26.2367 32.9302 29.694 33.4149 55.5852C33.8996 81.4764 49.8718 84.9792 56.0634 84.8643C85.0504 84.3222 96.4473 31.3204 75.7613 31.7072Z",
    fill: "url(#paint0_linear_390_3910)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7676 32.25H91.1454V33.9389H87.7676V32.25Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0557 32.25H81.4335V33.9389H78.0557V32.25Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9658 26.3398H85.6547V29.7177H83.9658V26.3398Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9668 36.0508H85.6557V39.4286H83.9668V36.0508Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8674 77.3744C29.4706 77.3744 28.334 76.2377 28.334 74.841C28.334 73.4443 29.4706 72.3076 30.8674 72.3076C32.2641 72.3076 33.4008 73.4443 33.4008 74.841C33.4008 76.2377 32.2641 77.3744 30.8674 77.3744ZM30.8674 73.9965C30.4012 73.9965 30.0229 74.3765 30.0229 74.841C30.0229 75.3055 30.4012 75.6855 30.8674 75.6855C31.3335 75.6855 31.7118 75.3055 31.7118 74.841C31.7118 74.3765 31.3335 73.9965 30.8674 73.9965Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6012 58.0545C58.4469 58.0545 59.9432 56.5406 59.9432 54.6731C59.9432 52.8056 58.4469 51.2916 56.6012 51.2916C54.7554 51.2916 53.2591 52.8056 53.2591 54.6731C53.2591 56.5406 54.7554 58.0545 56.6012 58.0545ZM56.6012 60.603C59.838 60.603 62.4621 57.9481 62.4621 54.6731C62.4621 51.3981 59.838 48.7432 56.6012 48.7432C53.3643 48.7432 50.7402 51.3981 50.7402 54.6731C50.7402 57.9481 53.3643 60.603 56.6012 60.603Z",
    fill: "#433ED1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9886 61.0205L56.7779 57.1729L58.4662 55.2816L62.6768 59.1292L60.9886 61.0205Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0224 68.965C49.3362 68.965 43.0801 62.7108 43.0801 55.0225C43.0801 47.3343 49.3362 41.0801 57.0224 41.0801C64.7087 41.0801 70.9648 47.3343 70.9648 55.0225C70.9648 62.7108 64.7087 68.965 57.0224 68.965ZM57.0224 44.0677C50.9834 44.0677 46.0677 48.9815 46.0677 55.0225C46.0677 61.0636 50.9834 65.9773 57.0224 65.9773C63.0615 65.9773 67.9771 61.0636 67.9771 55.0225C67.9771 48.9815 63.0615 44.0677 57.0224 44.0677Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1191 65.2451L67.2317 63.1325L74.1835 70.0844L72.071 72.197L65.1191 65.2451Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8467 39.9678L41.9593 37.8552L48.9111 44.807L46.7985 46.9196L39.8467 39.9678Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1201 44.8057L72.0719 37.8538L74.1845 39.9664L67.2327 46.9183L65.1201 44.8057Z",
    fill: "#433ED1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8447 70.0781L46.7965 63.1263L48.9091 65.2389L41.9573 72.1907L39.8447 70.0781Z",
    fill: "#433ED1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1005 78.9228C35.3539 78.9228 33.1211 76.688 33.1211 73.9433C33.1211 71.1986 35.3539 68.9639 38.1005 68.9639C40.8472 68.9639 43.0799 71.1986 43.0799 73.9433C43.0799 76.688 40.8472 78.9228 38.1005 78.9228ZM38.1005 71.9515C37.0011 71.9515 36.1087 72.8458 36.1087 73.9433C36.1087 75.0408 37.0011 75.9351 38.1005 75.9351C39.2 75.9351 40.0923 75.0408 40.0923 73.9433C40.0923 72.8458 39.2 71.9515 38.1005 71.9515Z",
    fill: "#433ED1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1005 41.08C35.3539 41.08 33.1211 38.8452 33.1211 36.1005C33.1211 33.3559 35.3539 31.1211 38.1005 31.1211C40.8472 31.1211 43.0799 33.3559 43.0799 36.1005C43.0799 38.8452 40.8472 41.08 38.1005 41.08ZM38.1005 34.1088C37.0011 34.1088 36.1087 35.0031 36.1087 36.1005C36.1087 37.198 37.0011 38.0923 38.1005 38.0923C39.2 38.0923 40.0923 37.198 40.0923 36.1005C40.0923 35.0031 39.2 34.1088 38.1005 34.1088Z",
    fill: "#433ED1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9443 41.08C73.1976 41.08 70.9648 38.8452 70.9648 36.1005C70.9648 33.3559 73.1976 31.1211 75.9443 31.1211C78.6909 31.1211 80.9237 33.3559 80.9237 36.1005C80.9237 38.8452 78.6909 41.08 75.9443 41.08ZM75.9443 34.1088C74.8448 34.1088 73.9525 35.0031 73.9525 36.1005C73.9525 37.198 74.8448 38.0923 75.9443 38.0923C77.0437 38.0923 77.936 37.198 77.936 36.1005C77.936 35.0031 77.0437 34.1088 75.9443 34.1088Z",
    fill: "#433ED1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9452 78.9228C73.1986 78.9228 70.9658 76.688 70.9658 73.9433C70.9658 71.1986 73.1986 68.9639 75.9452 68.9639C78.6919 68.9639 80.9246 71.1986 80.9246 73.9433C80.9246 76.688 78.6919 78.9228 75.9452 78.9228ZM75.9452 71.9515C74.8458 71.9515 73.9535 72.8458 73.9535 73.9433C73.9535 75.0408 74.8458 75.9351 75.9452 75.9351C77.0447 75.9351 77.937 75.0408 77.937 73.9433C77.937 72.8458 77.0447 71.9515 75.9452 71.9515Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_3910",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_3910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_3910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_3910",
    x1: 59.8564,
    y1: 26.1289,
    x2: 59.8564,
    y2: 84.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk7);
export default __webpack_public_path__ + "static/media/uwalk7.46e7fc691cb177aac9806e9cae82bd14.svg";
export { ForwardRef as ReactComponent };